import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import {
  Modal, ModalHeader, ModalBody, Button,
} from 'reactstrap';

import BaseGrid from '../Common/BaseGrid';
import * as url from '../../helpers/url_helper';

function ListingSearchModal(props) {
  const {
    shown, onClose, onSelect, t,
  } = props;
  const [selectedListing, setSelectedListing] = useState(null);

  const handleSelect = (row) => {
    setSelectedListing(row);
  };

  const handleConfirm = () => {
    if (selectedListing) {
      onSelect(selectedListing);
      setSelectedListing(null);
      onClose();
    }
  };

  const handleCancel = () => {
    setSelectedListing(null);
    onClose();
  };

  return (
    <Modal isOpen={shown} toggle={handleCancel} size="xl">
      <ModalHeader toggle={handleCancel}>
        {t('Select Listing')}
      </ModalHeader>
      <ModalBody>
        <BaseGrid
          url={url.GET_LISTINGS}
          hasSearch
          config={{
            columns: {
              select: {
                label: 'Select',
                actions: [
                  {
                    key: 'select',
                    icon: 'mdi mdi-check',
                    class: 'btn btn-sm btn-soft-danger',
                    alt: props.t('Select'),
                    click: (itm) => {
                      handleSelect(itm);
                    },
                  },
                ],
              },
              thumb: {
                label: '',
                image: {
                  src: (listing) => (`/api/listings/thumbnail/${listing.id}`),
                  class: 'rounded',
                  style: { maxHeight: '4rem', maxWidth: '4rem' },
                },
                translate: false,
              },
              id: {
                label: 'ID',
                sort: true,
                style: { minWidth: '100px' },
                link: {
                  to: '/listing/%id%',
                },
                html: true,
                format: (x, lst) => {
                  if (lst.last_qty > 0) {
                    // In Stock
                    return `<span class="badge bg-success"><span class="mdi mdi-check"></span></span> &nbsp;${x}`;
                  }

                  // OOS
                  return `<span class="badge bg-warning bg-soft"><span class="mdi mdi-close-thick text-dark"></span></span> &nbsp;${x}`;
                },
              },
              sku: {
                label: 'Sku',
                sort: true,
              },
              title: { label: 'Title', sort: true, style: { fontSize: '11px', maxWidth: '200px' } },
              condition: { label: 'Condition', sort: true, style: { fontSize: '11px' } },
              price: {
                label: 'Price',
                sort: false,
                format: (x) => new Intl.NumberFormat(
                  'en-US',
                  {
                    style: 'currency',
                    currency: 'USD',
                  },
                ).format(x),
                style: { fontSize: '11px' },
              },
              last_qty: {
                label: 'Qty for Sale',
                sort: true,
                style: { fontSize: '11px' },
              },
              created_at: {
                label: props.t('Created'),
                date: {
                  format: (date) => (moment(date).fromNow()),
                  timezone: process.env.LOCAL_TZ,
                },
                sort: true,
                style: { fontSize: '11px' },
              },
              tags: {
                label: 'Tags',
                format: (x) => (x.map((r) => (r.label))),
                badges: {
                  class: 'bg-info bg-soft text-dark p-1',
                },
              },
              channels: {
                label: 'Channels',
                format: (x) => (x.map((r) => (r.channel))),
                badges: {
                  class: 'bg-light text-dark p-1',
                },
              },
            },
            pagination: {
              sort: 'id',
              direction: 'desc',
              perPage: 10,
            },
          }}
        />
        <div className="mt-3 d-flex justify-content-end gap-2">
          <Button color="secondary" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button
            color="primary"
            onClick={handleConfirm}
            disabled={!selectedListing}
          >
            {t('Confirm Selection')}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

ListingSearchModal.defaultProps = {
  shown: false,
  onClose: () => {},
  onSelect: () => {},
};

ListingSearchModal.propTypes = {
  shown: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ListingSearchModal);
